export const OTP_VERIFIED_CONVERSION = 'AW-16634577510/PlZkCISzk8kcEOaE_vs9';

export const trackOtpVerifiedConversion = () => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', { send_to: OTP_VERIFIED_CONVERSION });
  }
};
